import * as ActionTypes from "../actions/ActionTypes";

const initialState = {
  tourismEvents: [],
  informativeTexts: [],
  sideMenuOpen: false,
  formMenuOpen: false,
  textMenuOpen: false,
  modifyFormMenuOpen: false,
  listMenuOpen: true,
  updateListMenu: false,
  uploadingImage: false,
  imageUrlResponse: "",
  deletingElement: false,
  creatingEvent: false,
  modifyingElement: false,
  modifyingInformativeText: false,
  eventToModify: {
    id: 0,
    type: "",
    titulo: "",
    info: "",
    link: "",
    imageUrl: ""
  },
  event: {
    imageUrl: ""
  },
  textToModify: {
    id: 0,
    type: "",
    title: "",
    info: ""
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOAD_TOURISMEVENTS:
      return {
        ...state,
        tourismEvents: action.events.data
      };
    case ActionTypes.LOAD_INFORMATIVETEXTS:
      return {
        ...state,
        informativeTexts: action.events.data
      };
    case ActionTypes.CREATE_TOURISMEVENT:
      return {
        ...state,
        creatingEvent: true
      };
    case ActionTypes.ONFINISHED_CREATE_TOURISMEVENT:
      return {
        ...state,
        creatingEvent: false
      };
    case ActionTypes.OPENCLOSE_SIDEMENU:
      return {
        ...state,
        sideMenuOpen: !state.sideMenuOpen
      };
    case ActionTypes.OPEN_FORMMENU:
      return {
        ...state,
        sideMenuOpen: false,
        listMenuOpen: false,
        textMenuOpen: false,
        formMenuOpen: true
      };
    case ActionTypes.OPEN_LISTMENU:
      return {
        ...state,
        sideMenuOpen: false,
        formMenuOpen: false,
        modifyFormMenuOpen: false,
        textMenuOpen: false,
        listMenuOpen: true
      };
    case ActionTypes.OPEN_TEXTSMENU:
      return {
        ...state,
        sideMenuOpen: false,
        formMenuOpen: false,
        modifyFormMenuOpen: false,
        listMenuOpen: false,
        textMenuOpen: true
      };
    case ActionTypes.DELETE_TOURISMEVENT:
      return {
        ...state,
        deletingElement: true
      };
    case ActionTypes.ONFINISHED_DELETE_TOURISMEVENT:
      return {
        ...state,
        deletingElement: false
      };
    case ActionTypes.MODIFY_TOURISMEVENT:
      return {
        ...state,
        modifyingElement: true
      };
    case ActionTypes.SET_MODIFY_TOURISMEVENT:
      return {
        ...state,
        eventToModify: action.eventToModify
      };
    case ActionTypes.ONFINISHED_MODIFY_TOURISMEVENT:
      return {
        ...state,
        modifyingElement: false
      };
    case ActionTypes.MODIFY_INFORMATIVETEXT:
      return {
        ...state,
        modifyingInformativeText: true
      };
    case ActionTypes.SET_MODIFY_INFORMATIVETEXT:
      return {
        ...state,
        textToModify: action.informativeText
      };
    case ActionTypes.ONFINISHED_MODIFY_INFORMATIVETEXT:
      return {
        ...state,
        modifyingInformativeText: false
      };
    case ActionTypes.UPLOADING_IMAGE:
      return {
        ...state,
        uploadingImage: true,
        event: {
          ...state.event,
          imageUrl: action.imageUrl
        }
      };
    default:
      return state;
  }
};

export default reducer;
